import React, { useState } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { Message } from '../../../utils/Message';
import { delay } from '../../../utils';
import { EditVehicleModalList } from '../../../constants';
import { useUser } from '../../../hooks/useUser';

import { updateVehicle } from '../../../service/api/Vehicle/apiVehicle';
import { getDeliver } from '../../../service/api/Deliver/apiDeliver';

const EditVehicleModal = ({ vehicle, onClose, onRefresh, mode = 'personal', companies = [], drivers = [] }) => {
    const [form, setForm] = useState({
        id: vehicle?.id,
        plate: vehicle?.plate,
        model: vehicle?.model,
        tonnage: vehicle?.tonnage,
        employeeId: vehicle?.employeeId || null,
        company: vehicle?.company || '',
        hasTailLift: vehicle?.hasTailLift || 0,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleCompanyChange = (e) => {
        const value = e.target.value;
        setForm(prev => ({ ...prev, company: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // 公司模式下，company 欄位應為空或 null
            const submitData = {
                ...form,
                company: (mode === 'personal' || !form.company) ? null : form.company
            };
            const response = await updateVehicle(form.id, submitData);
            if (response?.status === 200) {
                Message(response.data.message, 'success');
                await delay(1);
                onClose();
                onRefresh();
            }
        } catch (error) {
            console.error('更新失敗:', error);
            Message('更新失敗', 'error');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                    <div className="custom-modal-header">
                        <h5 className="modal-title">編輯車輛</h5>
                        <button className="btn-close" onClick={(e) => { onClose(); e.preventDefault(); }}></button>
                    </div>

                    <div className="custom-modal-body">
                        {EditVehicleModalList.map(field => (
                            (field.value !== 'employeeId' || mode === 'personal') && (
                                <div className="input-group mb-3" key={field.value}>
                                    {field.type === 'checkbox' ? (
                                        <>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                name={field.value}
                                                checked={form?.[field.value]}
                                                onChange={handleChange}
                                                id={field.value}
                                            />
                                            <label className="form-check-label ms-2" htmlFor={field.value}>
                                                {field.label}
                                                {field.required && <span className="required-star">*</span>}
                                            </label>
                                        </>
                                    ) : field.type === 'select' && field.isAsync ? (
                                        // 異步加載的選單（司機）
                                        <>
                                            <span className="input-group-text">
                                                {field.label}
                                                {field.required && <span className="required-star">*</span>}
                                            </span>
                                            <select
                                                className="form-select"
                                                name={field.value}
                                                value={form?.[field.value] || ''}
                                                onChange={handleChange}
                                                required={field.required}
                                                disabled={field.disabled}
                                            >
                                                <option value="">請選擇{field.label}</option>
                                                {drivers.map(driver => (
                                                    <option key={driver[field.valueField]} value={driver[field.valueField]}>
                                                        {driver[field.displayField]}
                                                    </option>
                                                ))}
                                            </select>
                                        </>
                                    ) : field.type === 'select' ? (
                                        <>
                                            <span className="input-group-text">
                                                {field.label}
                                                {field.required && <span className="required-star">*</span>}
                                            </span>
                                            <select
                                                className="form-select"
                                                name={field.value}
                                                value={Number(form?.[field.value]) ? 1 : 0}
                                                onChange={handleChange}
                                                required={field.required}
                                                disabled={field.disabled}
                                            >
                                                {field.options && field.options.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </>
                                    ) : (
                                        <>
                                            <span className="input-group-text">
                                                {field.label}
                                                {field.required && <span className="required-star">*</span>}
                                            </span>
                                            <input
                                                type={field.type}
                                                className="form-control"
                                                name={field.value}
                                                value={form?.[field.value]}
                                                onChange={handleChange}
                                                placeholder={field.placeholder || ""}
                                                required={field.required}
                                                disabled={field.disabled}
                                                step={field.step}
                                            />
                                        </>
                                    )}
                                </div>
                            )
                        ))}

                        {/* 公司選單 - 只在公司模式顯示 */}
                        {mode === 'company' && (
                            <div className="input-group mb-3">
                                <span className="input-group-text">
                                    公司
                                    <span className="required-star">*</span>
                                </span>
                                <select
                                    className="form-select"
                                    value={form.company || ''}
                                    onChange={handleCompanyChange}
                                    required
                                >
                                    <option value="">請選擇公司</option>
                                    {companies.map(company => (
                                        <option key={company.id} value={company.name}>
                                            {company.name}
                                        </option>
                                    ))}
                                    {/* 如果當前公司不在列表中，顯示它 */}
                                    {form.company && !companies.some(c => c.name === form.company) && (
                                        <option value={form.company} selected>
                                            {form.company}
                                        </option>
                                    )}
                                </select>
                            </div>
                        )}

                        {/* 個人模式時隱藏公司 */}
                        {mode === 'personal' && (
                            <input type="hidden" name="company" value="" />
                        )}
                    </div>

                    <div className="custom-modal-footer">
                        <button className="btn btn-secondary" onClick={(e) => { onClose(); e.preventDefault(); }}>取消</button>
                        <button className="btn btn-gradient-primary" type="submit">儲存</button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export { EditVehicleModal };
